<template>
  <div :id="listId" class="list-searchable">
    <div class="serchable-filters">
      <search-field
        class="list-searchable__search-field-container"
        input-class="list-searchable__search-field"
        :placeholder="searchInputPlaceholder"
        @search="onSearch($event)"
      >
      </search-field>

      <select
        class="user-select margin-filter"
        v-model="roleOfUser"
        @change="sortRole"
      >
        <option selected disabled hidden value="">Filtern nach:</option>
        <option value="Manager">Projektmanager</option>
        <option value="Technician">Monteure</option>
        <option value="Admin">Admins</option>
        <option value="SuperAdmin">Super Admins</option>
        <option value="">Alle</option>
      </select>
      <toggle-switch
        class="margin-filter"
        v-if="toogleshow"
        :value="0"
        label="Inaktive Mitarbeiter anzeigen"
        @on="filterItemStatus(true)"
        @off="filterItemStatus(false)"
      >
      </toggle-switch>
    </div>
    <ul
      :class="{ 'list-searchable__items': true, 'is-loading': isLoading }"
      ref="items"
    >
      <slot />
    </ul>
  </div>
</template>

<script>
import Base from "./Base";
import SearchField from "./SearchField";

export default {
  extends: Base,
  components: {
    "search-field": SearchField,
  },
  props: {
    listId: {
      type: String,
    },
    searchInputPlaceholder: {
      type: String,
    },
    toogleshow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      allUsers: [],
      isLoading: true,
      roleOfUser: "",
      filterStatus: false,
      searchValue: "",
    };
  },
  mounted() {
    let items = [];
    let currentFirstChar = "";

    // Get items and add char headers
    for (let item of this.$refs.items.children) {
      items.push(item);

      let itemValue = this.getItemValue(item);
      let itemFirstChar = itemValue[0].toUpperCase();

      item.setAttribute("data-first-char", itemFirstChar);

      if (currentFirstChar != itemFirstChar) {
        let charHeader = document.createElement("div");
        charHeader.classList.add("list-searchable__items__char-header");
        charHeader.innerText = itemFirstChar;
        charHeader.setAttribute("data-char", itemFirstChar);
        this.$refs.items.insertBefore(charHeader, item);
        currentFirstChar = itemFirstChar;
      }
    }

    this.items = items;
    this.allUsers = items;
    this.isLoading = false;
    if (this.items.length > 0 && this.toogleshow) {
      this.filterItemStatus(false);
    }
  },
  methods: {
    filterAllData() {
      const searchedItemRole = this.roleOfUser.toLowerCase();
      const searchString = this.searchValue;
      const filterActive = this.filterStatus;

      for (let item of this.items) {
        const itemValue = this.getItemValue(item);
        const itemFirstChar = itemValue[0].toUpperCase();
        const status = item.getAttribute("data-stuatus");
        const itemRole = item.getAttribute("data-role").toLowerCase();

        item.classList.remove("hidden");

        if (searchedItemRole.length > 0 && searchedItemRole != itemRole) {
          item.classList.add("hidden");
        }

        if (
          searchString.length != 0 &&
          itemValue.toLowerCase().indexOf(searchString) == -1
        ) {
          item.classList.add("hidden");
        }

        if (status == false && filterActive == false) {
          item.classList.add("hidden");
        }

        const charHeader = this.$refs.items.querySelector(
          `:scope > *[data-char="${itemFirstChar}"]`
        );
        const visiblieCharItems = this.$refs.items.querySelectorAll(
          `:scope > *[data-first-char="${itemFirstChar}"]:not(.hidden)`
        ).length;

        if (
          visiblieCharItems == 0 &&
          !charHeader.classList.contains("hidden")
        ) {
          charHeader.classList.add("hidden");
        } else if (
          visiblieCharItems > 0 &&
          charHeader.classList.contains("hidden")
        ) {
          charHeader.classList.remove("hidden");
        }
      }
    },
    filterItemStatus(value) {
      this.filterStatus = value;
      this.filterAllData();
    },
    sortRole() {
      this.filterAllData();
    },

    getItemValue(item) {
      return item.hasAttribute("data-value")
        ? item.getAttribute("data-value")
        : item.innerText;
    },
    onSearch(searchValue) {
      const searchString = searchValue.trim().toLowerCase();
      this.searchValue = searchString;
      this.filterAllData();
    },
  },
};
</script>

<style lang="scss">
.margin-filter {
  margin-bottom: 1rem;
}

.list-searchable {
  &__items {
    list-style-type: none;
    padding: 0;
    opacity: 1;

    &.is-loading {
      opacity: 0;
      transition: opacity 0.3s;
    }
  }
}
</style>